import ReactGA from 'react-ga';
import ApiService from 'services/ApiService';
import AnalyticsEventNames from './AnalyticsEventNames';

const googleAnalayticsTrackingId = window.__CONFIG__.GA_TRACKING_ID;

ReactGA.initialize(googleAnalayticsTrackingId);

function sendEvent(enrichedData) {
  if (enrichedData) {
    sendGAEvent(enrichedData);
    ApiService.sendAnalyticsEvent(enrichedData)
      .then(res => {})
      .catch(err => {});
  }
}

function sendGAEvent(enrichedData) {
  if (enrichedData) {
    ReactGA.set({
      userId: enrichedData.userId,
      orgId: enrichedData.orgId,
      // isPro: enrichedData.isPro,
      idUtPipl: enrichedData.idUtPipl,
    });
    ReactGA.event({
      category: enrichedData.eventCategory || '',
      action: enrichedData.eventName || '',
      label: enrichedData.eventLabel || '',
      value: enrichedData.eventValue,
    });
  }
}

function buildEvent({ user, tracking, eventName, eventCategory, eventLabel, eventValue, eventData }) {
  if (!tracking.isEnabled) {
    return null;
  }

  if (eventName === AnalyticsEventNames.PROFILE_TOOLTIP_OPEN_PERIOD && !tracking.isProfilePopupTimeEventEnabled) {
    return null; // disable flag for profile tooltips open time events
  }
  return {
    eventName,
    eventCategory: eventCategory || 'PRO_MANAGEMENT_BI_EVENTS',
    eventLabel,
    eventValue,
    ...eventData,

    idUtPipl: tracking.idUtPipl,
    userId: user.userId,
    username: user.username,
    orgId: user.orgId,
  };
}

export default { sendEvent, buildEvent, sendGAEvent };
